import { AxiosResponse } from "axios";
import { useRef, useState } from "react";
import { IOrdersReportParams } from "../../../connectors/orders/models";

interface DownloadFileProps {
  readonly apiDefinition: (response: any) => Promise<AxiosResponse>;
  readonly preDownloading: () => void;
  readonly postDownloading: () => void;
  readonly onError: () => void;
  readonly getFileName: () => string;
}

interface DownloadedFileInfo {
  readonly download: (params: IOrdersReportParams) => Promise<void>;
  readonly ref: React.MutableRefObject<HTMLAnchorElement | null>;
  readonly name: string | undefined;
  readonly url: string | undefined;
}

export const useDownloadFile = ({
  apiDefinition,
  preDownloading,
  postDownloading,
  onError,
  getFileName,
}: DownloadFileProps): DownloadedFileInfo => {
  const ref = useRef<HTMLAnchorElement | null>(null);
  const [url, setFileUrl] = useState<string>();
  const [name, setFileName] = useState<string>();

  const download = async (params: any) => {
    try {
      preDownloading();
      const { data } = await apiDefinition(params);
      const url = URL.createObjectURL(new Blob([data]));
      setFileUrl(url);
      setFileName(getFileName());
      if (ref.current) {
        ref.current.click();
      } else {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', getFileName());
        document.body.appendChild(link);
        link.click();
      }
      postDownloading();
      URL.revokeObjectURL(url);
    } catch (error) {
      onError();
    }
  };

  return { download, ref, url, name };
};
